export default "__VITE_ASSET__CpdDh6eN__"